import { Action } from 'redux';

import {
    GET_PROFILE_REQUEST,
    GET_PROFILE_RESPONSE,
    GET_PROFILE_ERROR
} from '../actions/profile';

import { Profile } from '../models/Profile';

export interface ProfileState {
    profile: Profile;
    loading: boolean;
    error: any;
}

const initialState: ProfileState = {
    profile: {
        available_delivery: 0,
        available_transfer: 0,
        common_delivery: 0,
        common_transfer: 0
    },
    loading: false,
    error: null,
};

export function profileState(state: ProfileState = initialState, action: Action) {
    switch (action.type) {
        case GET_PROFILE_REQUEST: {
            return {
                ...initialState,
                loading: true,
            };
        }
        case GET_PROFILE_RESPONSE: {
            const result = (action as any).response.result;
            if (result) {
                localStorage.setItem('phone', result.phone);
                localStorage.setItem('first_name', result.first_name);
                localStorage.setItem('channelUserId', result.channelUserId);
                localStorage.setItem('KON_TARIFF_ID', result.tariff.id);
            }
            const profile: Profile[] = result;
            return {
                ...state,
                loading: false,
                profile,
            };
        }
        case GET_PROFILE_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                loading: false,
                error,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/profile.ts